import { createAction, props } from '@ngrx/store';
import { User } from '../models';

const namespace = '[AUTH]';

export const PLAuthSuccess = createAction(
  `${namespace} Auth Success`,
  props<{
    user?: User;
    token?: string;
  }>()
);
export const PLAuthPending = createAction(`${namespace} Auth Pending`);
export const PLAuthError = createAction(
  `${namespace} Auth Error`,
  props<{ error: unknown }>()
);
export const PLCheckUserStatus = createAction(
  `${namespace} Check User Status`,
  props<{ lastActive?: number }>()
);
export const PLLoginRedirect = createAction(
  `${namespace} Login redirect`,
  props<{ url: string }>()
);

export const PLImpersonationStart = createAction(
  `${namespace} Impersonation Start`,
  props<{
    token: string;
    userData: any;
    targetUserId: string;
    expiresAt: number | null;
  }>()
);

export const PLImpersonationStop = createAction(
  `${namespace} Impersonation Stop`
);
